<template>
  <l-layout :layout="['xs12']" bottom-space>
    <div v-if="hasPermission">
      <l-data-table
        :get-data-func="getItems"
        :headers="(isSelf)?headers_self:headers_all"
        @click:row="goDetails($event.item)"
        clickable
        :filter-items="filter"
        init-sort-by="creationTime"
        ref="dataTable"
        search-text="搜索车牌"
        title-text="单位预约"
      >
        <template slot="filter:creationTime" slot-scope="{filter}">
          <div>filter{{filter.key}}{{filter.value}}</div>
        </template>
        <template slot="filter:ownerId">
          <v-autocomplete
            :items="userSelect"
            v-model="filter[4].value"
            v-on:keyup="getUsers"
            label="用户账号"
            clearable
            hide-details
            hide-selected
            item-text="loginId"
            item-value="loginId"
            prepend-icon="$vuetify.icons.person"
          >
            <template slot="no-data">
              <v-alert :value="true" color="error">
                暂无该用户信息
              </v-alert>
            </template>
            <template slot="item" slot-scope="props">
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-flex row align-center justify-between>
                    <span>{{props.item.name}}</span>
                  </v-flex>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
              </v-list-tile-action>
            </template>
          </v-autocomplete>
        </template>
        <template slot="title">
          <span class="pl-2 pr-4">单位预约</span>
          <v-radio-group v-if="isAdmin" mandatory row v-model="isSelf">
            <v-radio :value="true" label="个人"></v-radio>
            <v-radio :value="false" label="全部"></v-radio>
          </v-radio-group>
          <v-btn flat color="primary"  :loading="loading" @click="outputExcel">导出excel</v-btn>
        </template>
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-btn @click="deleteItem(item)" icon :disabled="item.status==='-1'">
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="goNew"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </div>
    <div v-else>
      {{errMsg}}
    </div>
  </l-layout>
</template>

<script>

import {ADMIN_HEADERS, ADMIN_ACTION_HEADERS} from '@/consts/reservation'
import {ReservationAuthority} from '../../../object'
import {PERMISSION} from '../../../consts/userAdmin'
import {time} from '../../../ladmin/utils'
export default {
  name: 'OrgReservation',
  props: ['refresh'],
  data: () => ({
    hasPermission:true,
    errMsg:'',
    selected: [],
    isSelf: true,
    isSelfHistory: true,
    floatingButton: false,
    showHistory: false,
    loading:false,
    amount:0,
    headers_self: ADMIN_HEADERS,
    headers_all: ADMIN_ACTION_HEADERS,
    userSelect: [],
    fileHeader:[
      { k: 'plate', v: '车辆号牌' },
      { k: 'phone', v: '访客手机' },
      { k: 'name', v: '访客姓名' },
      { k: 'startDatetime', v: '开始时间' },
      { k: 'endDatetime', v: '结束时间' },
      { k: 'status', v: '是否有效' },
    ],
    filter: [
      {
        prependIcon: '$vuetify.icons.edit',
        key: 'status',
        value: '{"r_h_status":"1"}',
        label: '是否有效',
        type: 'select',
        layout: ['xs12', 'sm4'],
        items: [
          {
            value: '',
            text: '全部'
          },
          {
            value: '{"r_h_status":"1"}',
            text: '有效'
          },
          {
            value: '{"r_h_status":"-1"}',
            text: '失效'
          },
        ],
      },
      {
        label: '开始时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'startDatetime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            let s = time.toTimeStamp(v.startDatetime) || 0
            let e = time.toTimeStamp(v.endDatetime) || 9999999999999
            return [s, e]
          }
        }
      },
      {
        label: '截止时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'endDatetime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            let s = time.toTimeStamp(v.startDatetime) || 0
            let e = time.toTimeStamp(v.endDatetime) || 9999999999999
            return [s, e]
          }
        }
      },
      {
        prependIcon: '$vuetify.icons.phone',
        key: 'visitorPhone',
        value: '',
        label: '联系电话',
        type: 'input',
        layout: ['xs12', 'sm4'],
      },
      {
        prependIcon: '',
        key: 'ownerId',
        value: '',
        label: '用户ID',
        type: 'input',
        layout: ['xs12', 'sm4'],
      },
    ]
  }),
  computed: {
    filterItems () {
      return [
        {
          key: 'creationTime',
          value: '',
          type: 'input'
        }
      ]
    },
    isAdmin () {
      return this.$store.getters['login/hasPermissionOf'](PERMISSION.RESERVATION.ORG.ADMIN)
    }
  },
  watch: {
    isSelf () {
      this.$refs.dataTable.refresh()
    },
    isSelfHistory () {
      this.$refs.dataTableHistory.refresh()
    }
  },
  methods: {
    async getUsers (param) {
      let search = (param === undefined) ? '' : param.target.value + ''
      let pagination = {page: 0, rowsPerPage: 10}
      let searchParam = {
        'searchParam': {
          'loginId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.userSelect = res.data.data.content
        console.log(this.userSelect)
      }
      else {
        this.userSelect = []
      }
    },
    async getItems ({pagination, sortStack, filterItems, search}) {
      let {items,amount} = await this.$store.dispatch('reservation/getOrgReservations', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'plate', value: search},
        self: this.isSelf
      })
      this.amount = amount
      return {items:items,amount:amount}
    },
    async getItemsHistory ({pagination, sortStack, filterItems, search}) {
      let {items,amount}  = await this.$store.dispatch('reservation/getOrgReservationsHistory', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'plate', value: search},
        self: this.isSelfHistory
      })
      this.amount = amount
      return {items:items,amount:amount}
    },
    goDetails (item, isHistory) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'OrgReservationDetails',
          params: {plate: item.plate},
          query: {id: item.id, history: isHistory || undefined}
        })
      }
    },
    goNew () {
      this.$router.push({
        name: 'NewOrgReservation'
      })
    },
    async getReservationConfig () {
      let res = await this.$store.dispatch('reservationConfig/getReservationConfig', 'order_group')
      console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '单位预约',
          maxVehicleAmount: 1000,
          maxStartDay: res.data.data.maxAdvDays,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          limitAreaConfigs: res.data.data.limitAreaConfigs
        })
        // console.log(object)
        this.$store.commit('reservation/setOrgAuth', object)
      }
      else {
        this.hasPermission = false
        this.errMsg = res.data.msg
        //this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    async deleteItem (item) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该预约，车牌号码：' + item.plate})
      if (res) {
        try {
          let ids = []
          ids.push(item.id)
          let res = await this.$store.dispatch('reservation/deleteVehicles', { ids, force: 'false' })
          if (res.data.status === 1) {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.dataTable.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async outputExcel(){
      let pagination = {
        page:1,
        rowsPerPage: this.amount
      }
      this.loading = true
      let {items} = await this.$store.dispatch('reservation/getOrgReservations', {
        pagination,
        filter: this.filter,
        self: this.isSelf
      })
      const ExportJsonExcel = require('js-export-excel')
      let option = {}
      let list = []
      items.forEach((item)=>{
        item.startDatetime = time.stringify(item.startDatetime)
        item.endDatetime = time.stringify(item.endDatetime)
        item.status = (item.status === '1' ? '有效' : '失效')
        let arr = []
        for(let i in this.fileHeader){
          arr.push(item[this.fileHeader[i].k])
        }
        list.push(arr)
      })
      option.fileName = "单位预约记录表"
      option.datas=[
        {
          sheetData:list,
          sheetName:'sheet',
          sheetHeader:['车辆号牌','访客手机','访客姓名','开始时间','结束时间','是否有效'],
        },
      ];
      let toExcel = new ExportJsonExcel(option); //new
      toExcel.saveExcel(); //保存
      this.loading = false
    }
  },
  created () {
    this.getReservationConfig()
  },
  activated () {
    if (this.refresh) {
      this.$refs.dataTable.refresh()
    }
  }
}
</script>

<style scoped>

</style>
